import { useState, useCallback } from 'react';
export const useStatus = () => {
    const [status, setStatus] = useState([]);
    const [loading, setLoading] = useState(false);
    const addStatus = useCallback((message) => {
        setStatus(prev => [...prev.slice(-10), message]); // Keep last 10 messages
        // Removed event emission for status banner - no longer needed
    }, []);
    return {
        status,
        loading,
        addStatus,
        setLoading
    };
};
